import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ErrorBag } from '../../datastores/errorBag'

export const LabeledInputField = ({
    labelText,
    id,
    required = false,
    className = '',
    errorMessage = '',
    forwardedRef = null,
    onFocus = null,
    onBlur = null,
    onChange = null,
    value = null,
    forceErrorDisplay = false,
    ...inputProps
}) => {

    const [focused, setFocused] = useState(false)
    const [blurred, setBlurred] = useState(value !== '' && value != null)
    const [displayError, setDisplayError] = useState(false)

    useEffect(() => {

        if(errorMessage !== '' && blurred && !focused) {
            setDisplayError(true);
        } else {
            setDisplayError(false);
        }

    }, [errorMessage, blurred])
  const el = useRef()
  useEffect(() => {
    ErrorBag.getInstance().register(id, el)
    }, [])

    let classes = classNames('mtt-input-field', className, {
        'error': displayError || forceErrorDisplay,
        'mtt-input-field--active': focused || (value != null && value !== '')
    })

    return (
        <div className={classes} ref={el}>
            <label className='mtt-input-field__label' htmlFor={id}>
                {labelText}{required ? (<span className='required'>*</span>) : null}
            </label>
            <input
                {...inputProps}
                id={id}
                value={value}
                ref={forwardedRef || null}
                onFocus={(e) => {
                    if(typeof onFocus === 'function') {
                        onFocus(e)
                    }

                    setFocused(true);
                }}
                onBlur={(e) => {
                    if(typeof onBlur === 'function') {
                        onBlur(e)
                    }

                    setFocused(false);
                    setBlurred(true);
                }}
                onChange={(e) => {
                    if(typeof onChange === 'function') {
                        onChange(e)
                    }

                    setBlurred(false);
                    setDisplayError(false);
                }}
            />
            { displayError || forceErrorDisplay ? (
                <span className={'mtt-input-field__error'}>
					{errorMessage}
				</span>
            ) : null}
        </div>
    )
}

LabeledInputField.propTypes = {
    labelText: PropTypes.string,
    required: PropTypes.bool,
    className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
    errorMessage: PropTypes.string,
    forwardedRef: PropTypes.any
}
